// FlixMessageId.jsx
import React from 'react';
import { useLoaderData } from 'react-router';

import MetaTagsHelmet from '../component/MetaTagsHelmet.jsx';
import MongoObjectIdMatcher from '../component/MongoObjectIdMatcher.jsx';
import Redirect from '../container/Redirect.js';
import { EMPTY_ARRAY } from '../resource/defaults.js';
import { reactRouterNoindexLoader } from '../resource/reactRouterNoindexLoader.js';

export const loader = reactRouterNoindexLoader;

const FlixMessageIdRoute = () => {
  const { meta = EMPTY_ARRAY } = useLoaderData();

  return (
    <>
      <MetaTagsHelmet metaTags={meta} />
      <MongoObjectIdMatcher paramKeys={['messageId']}>
        <Redirect to="/post/:messageId" status={301} />
      </MongoObjectIdMatcher>
    </>
  );
};

export default FlixMessageIdRoute;
